import type { FaireProductEntity } from "../../entity_types/product";

export const p_eyvxf8x8t4: FaireProductEntity = {
  token: "p_eyvxf8x8t4",
  type: "product",
  name: "Konosuba: God's Blessing on This Wonderful World!, Vol. 10",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/9853fd8d7a79d6b95ff750ddc61f1cf3751eaecffe3ca3a81c4606a8610383d8.webp",
  galleryImageUrls: [],
  priceDollars: 6.5,
  description: "After a rocky start, Iris is getting along with Kazuma splendidly, and she’s even taken a liking to our hero and his boorish ways. Claire, however, is still not impressed, and she wants him as far away from the princess as possible. But Kazuma’s grown attached to his new little sister, and no matter how low he has to sink, he’s determined to do whatever it takes to stay by her side!",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:35.730Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
